import { useLocation } from 'react-router-dom';
import { HIDDEN_ELEMENT_PATHS } from '../routes';

export const useElementVisibility = () => {
  const location = useLocation();
  const current = location.pathname.toLowerCase();
  return !HIDDEN_ELEMENT_PATHS.some(path =>
    current.startsWith(path.toLowerCase())
  );
};
